import { useCallback } from 'react'
import { gql, useMutation } from '@apollo/client'

export default (onSuccess, onError) => {
  const [mutation, { data, error, loading }] = useMutation(
    gql`mutation changeEducatorsToPlan(
      $plansIds: [ID!]!
      $educatorToReplaceId: ID
      $newEducatorId: ID!
      $topicIds: [ID!]
    ) {
      changeEducatorsToPlan(
        plansIds: $plansIds
        educatorToReplaceId: $educatorToReplaceId
        newEducatorId: $newEducatorId
        topicIds: $topicIds
      )
    }`
  )

  const submit = useCallback((obj) => {
    return mutation({ variables: obj })
      .then((result) => {
        onSuccess({ ...result, variables: obj })
      })
      .catch((e) => {
        onError(e)
      })
  }, [mutation, onSuccess, onError])

  const submitBatch = useCallback(async (operations) => {
    try {
      const results = []
      for (const operation of operations) {
        results.push(await mutation({ variables: operation }))
      }
      onSuccess({ results, variables: operations })
      return results
    } catch (error) {
      onError(error)
      throw error
    }
  }, [mutation, onSuccess, onError])

  return {
    loading,
    data: data?.changeEducatorsToPlan || null,
    error,
    submit,
    submitBatch
  }
}
